import { render } from "./Table3.vue?vue&type=template&id=8ccb0032"
import script from "./Table3.vue?vue&type=script&lang=js"
export * from "./Table3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__